const HAS_LETTER = /[A-Za-zÀ-ÿ]/;
const ACCEPTED_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];
const ACCEPTED_EXTENSIONS = /\.(jpe?g|png)$/i;
export const PROOF_MAX_SIZE = 15 * 1024 * 1024;

export function validateProofPhoto(file: File): string | null {
  if (!ACCEPTED_TYPES.includes(file.type.toLowerCase()) && !ACCEPTED_EXTENSIONS.test(file.name)) {
    return 'A foto deve estar nos formatos JPG, JPEG ou PNG.';
  }
  if (file.size > PROOF_MAX_SIZE) {
    return 'A foto deve ter no máximo 15 MB.';
  }
  return null;
}

export function validateReceiverName(receiverName: string): string | null {
  const trimmed = (receiverName ?? '').trim();
  if (trimmed.length === 0) {
    return 'Informe o nome de quem recebeu.';
  }
  if (trimmed.length < 3) {
    return 'O nome de quem recebeu deve ter no mínimo 3 caracteres.';
  }
  if (!HAS_LETTER.test(trimmed)) {
    return 'O nome de quem recebeu deve conter ao menos uma letra.';
  }
  return null;
}
